import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient
} from '@tanstack/react-query'
import {
  listWithdrawalRequests,
  setWithdrawalRequestClosed
} from '@/api/processes-api'

export const WITHDRAWALS_PAGE_SIZE = 25

export function useWithdrawalRequests(
  ecommerceId: string | undefined,
  offset: number
) {
  return useQuery({
    queryKey: ['withdrawal-requests', ecommerceId, offset],
    queryFn: () =>
      listWithdrawalRequests(ecommerceId ?? '', offset, WITHDRAWALS_PAGE_SIZE),
    enabled: !!ecommerceId,
    placeholderData: keepPreviousData
  })
}

export function useSetWithdrawalClosed(ecommerceId: string | undefined) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, closed }: { id: string; closed: boolean }) =>
      setWithdrawalRequestClosed(ecommerceId ?? '', id, closed),
    // The status is worked out by the list, so it's read again.
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ['withdrawal-requests', ecommerceId]
      })
  })
}
